// Look and Feel — the frontend side of the site-wide branding settings.
//
// A tiny external store (no context plumbing): the app shell calls
// applyLookAndFeel() once the PWA-global settings load (App.jsx
// AuthGuard) and again when an admin saves the Settings form, and any
// component renders from it via useLookAndFeel(). The favicon is applied
// here directly — it lives on document.head, not in any component tree.
//
// Every value is optional; absent means the product default (the config
// seam's brand, the CSS token colours, the bundled logo assets).

import { useSyncExternalStore } from 'react';

let current = {};
const subscribers = new Set();

// The favicon href shipped with the build — captured before the first
// override so Reset restores it without a reload.
let defaultFaviconHref;

function applyFavicon(dataUri) {
  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  if (defaultFaviconHref === undefined) defaultFaviconHref = link.href || '';
  link.href = dataUri || defaultFaviconHref;
}

export function applyLookAndFeel(cfg) {
  current = cfg && typeof cfg === 'object' ? cfg : {};
  try { applyFavicon(current.faviconDataUri || null); } catch { /* head not writable (tests) */ }
  subscribers.forEach((fn) => fn());
}

const subscribe = (fn) => { subscribers.add(fn); return () => subscribers.delete(fn); };
const getSnapshot = () => current;

export function useLookAndFeel() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

// '#rrggbb' → 'r, g, b' for rgba(var(--…-rgb), a) usage in TopNav.css.
export function hexToRgbTriplet(hex) {
  if (!/^#[0-9a-fA-F]{6}$/.test(hex || '')) return null;
  return [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(', ');
}
